import React from "react";
import PropTypes from "prop-types";

import { OrcaCommonProvider } from "./OrcaCommonContext";
import { CoreFeatureStack } from "./featureStacks/CoreFeatureStack";

export const OrcaContextProvider = ({
  DataProviderComponent,
  OptionalFeatureStack,
  uuid,
  video,
  videoStartId,
  isSandbox,
  config,
  orcaRef,
  children,
  stickyPlayerContext = {},
  orcaDeps,
  carouselState,
  optionalHandlers
}) => {
  return (
    <CoreFeatureStack
      DataProviderComponent={DataProviderComponent}
      uuid={uuid}
      video={video}
      videoStartId={videoStartId}
      isSandbox={isSandbox}
      config={config}
      orcaRef={orcaRef}
      orcaDeps={orcaDeps}
    >
      <OptionalFeatureStack
        stickyPlayerContext={stickyPlayerContext}
        config={config}
        orcaDeps={orcaDeps}
        carouselState={carouselState}
      >
        <OrcaCommonProvider {...{ config, optionalHandlers }}>
          {children}
        </OrcaCommonProvider>
      </OptionalFeatureStack>
    </CoreFeatureStack>
  );
};

OrcaContextProvider.propTypes = {
  DataProviderComponent: PropTypes.elementType.isRequired,
  OptionalFeatureStack: PropTypes.elementType.isRequired,
  uuid: PropTypes.string.isRequired,
  video: PropTypes.object,
  videoStartId: PropTypes.string,
  isSandbox: PropTypes.bool,
  config: PropTypes.object,
  orcaRef: PropTypes.object,
  children: PropTypes.node.isRequired,
  stickyPlayerContext: PropTypes.object,
  orcaDeps: PropTypes.object,
  carouselState: PropTypes.object,
  optionalHandlers: PropTypes.shape({
    toggleSubsHandler: PropTypes.func,
    toggleMuteHandler: PropTypes.func
  })
};
